import {FilterTextComponentInterface} from '../../partial-components/filters/filter-text/filter-text.component';

export const DeviceFilterTextConfig: FilterTextComponentInterface = {
    inputPlaceholder: 'balrogadminApp.device.filters.filterTextPlaceholder'
};
